import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { FiltersProgramArticleDashboard, IFiltersProgramArticleDashboard } from '../../store/actions/filters-program-article-dashboard.actions';
import { FiltersActions, FiltersStateInterface } from '../../store/actions/filters.actions';

@Component({
  selector: 'app-date-filter-picker',
  templateUrl: './date-filter-picker.component.html',
  styleUrls: ['./date-filter-picker.component.scss']
})
export class DateFilterPickerComponent {

  startDate: Date;
  endDate: Date;
  midnightMode: boolean;
  /**
   * Five weeks
   * @type {number}
   */
  limit = 1000 * 60 * 60 * 24 * 7 * 5;

  @Input() showMidnightMode = true;
  @Input() isDashboard = false;

  /**
   * Get start date and end date from the filters store
   * @param {Store<any>} store
   * @param {FiltersActions} filtersActions
   */
  constructor(private store: Store<any>,
    private filtersActions: FiltersActions,
    private filtersProgramArticleDashboard: FiltersProgramArticleDashboard) {
  }

  ngOnInit() {
    if (this.isDashboard) {
      this.store.select('filtersProgramArticleDashboard').subscribe((filters: IFiltersProgramArticleDashboard) => {
        this.startDate = filters.startDate;
        this.endDate = filters.endDate;
        this.midnightMode = filters.midnightMode;
      });
    } else {
      this.store.select('filtersState').subscribe((filtersState: FiltersStateInterface) => {
        this.startDate = filtersState.startDate;
        this.endDate = filtersState.endDate;
        this.midnightMode = filtersState.midnightMode;
      });
    }
  }

  /**
   * When start date change, check if the start date is before the end date and the period is lower than a week
   */
  startDateChanged() {
    if (this.startDate) {
      if (this.startDate.getTime() > this.endDate.getTime()) {
        this.endDate = this.startDate;
      }
      if (this.endDate.getTime() - this.startDate.getTime() > this.limit) {
        this.endDate = new Date(this.startDate.getTime() + this.limit);
      }
      this.dateChanged();
    }
  }

  /**
   * When end date change, check if the start date is before the end date and the period is lower than a week
   */
  endDateChanged() {
    if (this.endDate) {
      if (this.endDate.getTime() < this.startDate.getTime()) {
        this.startDate = this.endDate;
      }
      if (this.endDate.getTime() - this.startDate.getTime() > this.limit) {
        this.startDate = new Date(this.endDate.getTime() - this.limit);
      }
      this.dateChanged();
    }
  }

  dayStartChanged(event) {
    this.midnightMode = event.checked;
    this.dateChanged();
  }

  /**
   * When a date change, save theses dates in the filters store
   */
  dateChanged() {
    if (this.isDashboard) {
      this.filtersProgramArticleDashboard.setDates(this.startDate, this.endDate, this.midnightMode);
    } else {
      this.filtersActions.setDates(this.startDate, this.endDate, this.midnightMode);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/date-filter-picker/date-filter-picker.component.ts